import { render, staticRenderFns } from "./SearchPostsList.vue?vue&type=template&id=31cb667e&scoped=true"
import script from "./SearchPostsList.vue?vue&type=script&lang=js"
export * from "./SearchPostsList.vue?vue&type=script&lang=js"
import style0 from "./SearchPostsList.vue?vue&type=style&index=0&id=31cb667e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cb667e",
  null
  
)

export default component.exports